import { useMutation, useQuery, useQueryClient } from "react-query";
import { productCategoriesHttp } from "./product-categories-http";
import { OrganizationKeyName } from "../../../model/Organization";

const productCategoriesCacheKeys = {
  productCategories: "productCategories",
  productCategory: "productCategory",
};

export const useUploadProductCategoryImage = () => {
  return useMutation(productCategoriesHttp.uploadProductCategoryImage);
};

export const useGetProductCategories = (
  organizationKeyName?: OrganizationKeyName
) => {
  return useQuery(
    [productCategoriesCacheKeys.productCategories],
    () => productCategoriesHttp.getProductCategories(organizationKeyName),
    { refetchOnWindowFocus: false }
  );
};

export const useGetProductCategory = (
  organizationKeyName?: OrganizationKeyName,
  id?: string
) => {
  return useQuery(
    [productCategoriesCacheKeys.productCategory, id],
    () => productCategoriesHttp.getProductCategory(organizationKeyName, id),
    { refetchOnWindowFocus: false, enabled: !!id }
  );
};

export const useCreateProductCategory = () => {
  const queryClient = useQueryClient();

  return useMutation(productCategoriesHttp.createProductCategory, {
    onSuccess: async () => {
      queryClient.refetchQueries([
        productCategoriesCacheKeys.productCategories,
      ]);
    },
  });
};

export const useUpdateProductCategory = (id?: string) => {
  const queryClient = useQueryClient();

  return useMutation(productCategoriesHttp.updateProductCategory, {
    onSuccess: async () => {
      queryClient.refetchQueries([
        productCategoriesCacheKeys.productCategories,
      ]);
      if (id) {
        queryClient.refetchQueries([
          productCategoriesCacheKeys.productCategory,
          id,
        ]);
      }
    },
  });
};

export const useArchiveProductCategory = () => {
  const queryClient = useQueryClient();

  return useMutation(productCategoriesHttp.archiveProductCategory, {
    onSuccess: async () => {
      queryClient.refetchQueries([
        productCategoriesCacheKeys.productCategories,
      ]);
    },
  });
};

export const useUpdateProductCategorySorting = () => {
  const queryClient = useQueryClient();

  return useMutation(productCategoriesHttp.updateProductCategorySorting, {
    onSuccess: async () => {
      queryClient.refetchQueries([
        productCategoriesCacheKeys.productCategories,
      ]);
    },
  });
};
